import {
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@montugroup/design-system';
import { useId } from 'react';

import { ErrorAlert } from '@/components/common/RebrandStyledComponents';
import { WaitlistDialog } from './PostBookingWaitlistDialog.styles';
import { ActionButton } from './WaitlistPreferenceForm.styles';

export interface LeaveWaitlistDialogProps {
  open: boolean;
  isLeaving: boolean;
  errorMessage: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export function LeaveWaitlistDialog({ open, isLeaving, errorMessage, onConfirm, onCancel }: LeaveWaitlistDialogProps) {
  const titleId = useId();
  const descriptionId = useId();

  return (
    <WaitlistDialog
      open={open}
      onClose={isLeaving ? undefined : onCancel}
      aria-labelledby={titleId}
      aria-describedby={descriptionId}
    >
      <DialogTitle id={titleId}>Leave the waitlist?</DialogTitle>
      <DialogContent>
        <DialogContentText id={descriptionId}>
          You&apos;ll keep your current appointment but won&apos;t be offered earlier times.
        </DialogContentText>
        {errorMessage && <ErrorAlert severity="error">{errorMessage}</ErrorAlert>}
      </DialogContent>
      {/* primary action first, as in the join form */}
      <DialogActions disableSpacing>
        <ActionButton
          variant="contained"
          color="primary"
          onClick={onConfirm}
          disabled={isLeaving}
          startIcon={isLeaving ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          Leave waitlist
        </ActionButton>
        <ActionButton variant="outlined" onClick={onCancel} disabled={isLeaving}>
          Stay on the waitlist
        </ActionButton>
      </DialogActions>
    </WaitlistDialog>
  );
}
